import React from 'react';
import ReactCountryFlag from 'react-country-flag';

import { Text } from './text';
import { IPlayer } from '../models/player';
import { worldAlpha2Mapping } from '../models/countryCodes';
import Link from 'next/link';

interface IProps {
	player: IPlayer;
	className?: string;
}

export function PlayerCard({ player, className }: IProps) {
	const cardClassName = className || '';
	const foundCountryCode = worldAlpha2Mapping[player.passport.nationality];

	return (
		<div className={`rounded-md flex flex-col bg-white w-full max-w-xs border ${cardClassName}`}>
			<div className="w-full bg-red-500 relative h-[220px] bg-[url('/images/shield.png')] bg-no-repeat bg-right-bottom  bg-contain">
				<div className="absolute bottom-0 right-0">
					<img
						src={player.playerPhoto || '/images/player-profile.png'}
						alt={`${player.passport.firstName} ${player.passport.lastName}`}
						className="h-[200px] w-auto"
					/>
				</div>
				<div className="kkd-gradient-red-overlay-y absolute bottom-0 left-0"></div>
				{player.passport.shirtNumber && (
					<div className="absolute bottom-6 left-6">
						<Text className="text-7xl text-white font-bold">{player.passport.shirtNumber}</Text>
					</div>
				)}
			</div>
			<div className="px-6 py-8 flex">
				<div className="flex-1">
					<Text className="font-bold mb-1 block">{player.passport.shortFirstName}</Text>
					<Text className="block break-all leading-none font-theinhardt font-bold text-xl lg:text-3x uppercase">
						{player.passport.shortLastName}
					</Text>
				</div>
				{foundCountryCode && (
					<div className="flex-none ml-3 self-end">
						<ReactCountryFlag countryCode={foundCountryCode} svg style={{ width: '2em' }} />
					</div>
				)}
			</div>
		</div>
	);
}
